import apiClient from "./apiClient";

const STOCK = "/api/Stock";
const PRODUCT = "/api/Product";

const toDate = (d) => (d ? `${d}T00:00:00` : null);
const toNum = (v) => Number(v) || 0;

// Current stock is derived from products (currentStock field on each product)
export const getCurrentStock = () => apiClient.get(`${PRODUCT}/all`);

// Stock adjustment — modal sends flat single-item; API expects header + details array
export const createStockAdjustment = (data) => {
  const qty = toNum(data.quantity);
  const currentQty = toNum(data.currentQty);
  const adjustedQty = data.adjustmentType === "Add" ? qty : -qty;
  const newQty = currentQty + adjustedQty;
  return apiClient.post(`${STOCK}/adjust`, {
    adjustmentDate: toDate(data.adjustmentDate),
    reason: data.adjustmentType || "Add",
    remarks: data.reason || "",
    details: [{ productID: toNum(data.productID), currentQty, adjustedQty, newQty }],
  });
};
export const getStockAdjustments = () => apiClient.get(`${STOCK}/adjust/all`);
export const getStockAdjustment = (id) => apiClient.get(`${STOCK}/adjust/${id}`);
export const updateStockAdjustment = (id, data) => apiClient.put(`${STOCK}/adjust/${id}`, data);
export const deleteStockAdjustment = (id) => apiClient.delete(`${STOCK}/adjust/${id}`);
